var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DynamicTabs',{attrs:{"tabs":_vm.tabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }